import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { getTranslatedOptions } from '../../../../utils/translation'
import Button from '../../../Button'
import { ButtonIconSelectControl, ButtonSelect } from '../../../Select'

import {
  EMAIL_ADD_BUTTON_OPTIONS,
  QA_NAME_REQUEST_PROFILE_TAB_EMAILS_ADD_BUTTON,
} from './RequestProfileTabEmailsAddButton.constants'

import * as styles from './RequestProfileTabEmailsAddButton.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabEmailsAddButton({ onSelect }) {
  const { t } = useTranslation()

  const options = getTranslatedOptions({ options: EMAIL_ADD_BUTTON_OPTIONS, t })

  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      controlProps={{
        Button: Button.Text,
        buttonProps: {
          beforeIconProps: { Icon: PlusIcon },
          text: t('RequestProfile.AddNewEmailBtnKey'),
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        maxWidthByRef: false,
      }}
      dropdownProps={{
        className: styles.dropdown,
      }}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      options={options}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_EMAILS_ADD_BUTTON}
      onSelectItem={onSelect}
    />
  )
}

export default RequestProfileTabEmailsAddButton
